import React from 'react';
import { Layout, Button, Dropdown, Space } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, LogoutOutlined } from '@ant-design/icons';

const { Header } = Layout;

const AppHeader = ({ collapsed, setCollapsed, user, onLogout }) => {
  // 用户角色中文名映射
  const roleNameMap = {
    'boss': '老板',
    'manager': '店长',
    'staff': '员工'
  };

  // 下拉菜单项
  const items = [
    {
      key: '1',
      label: (
        <div style={{ padding: '4px 8px' }}>
          <div><strong>{user?.name}</strong></div>
          <div style={{ color: '#999' }}>{roleNameMap[user?.role]}</div>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: '2',
      label: '退出登录',
      icon: <LogoutOutlined />,
      onClick: onLogout,
    },
  ];

  return (
    <Header
      style={{
        padding: 0,
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: '16px',
          width: 64,
          height: 64,
        }}
      />
      <div style={{ paddingRight: 24 }}>
        <Dropdown menu={{ items }} placement="bottomRight">
          <Space>
            <Button type="text" icon={<UserOutlined />}>
              {user?.name}
            </Button>
          </Space>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader; 